/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Component, Element, Event, EventEmitter, h, Prop } from "@stencil/core";
import { VideoplayerLocalization, VideoplayerProgressEventArgs } from "../constants/videoplayer-types";
import { formatTime } from "../../../utils/date-helper";
import { stringFormat } from "../../../utils/string-format";
import pfx from "../../../utils/style-class-prefix-helper";

@Component({
  tag: "eon-ui-videoplayer-controls",
  styleUrl: "controls.scss",
  shadow: false
})
export class VideoplayerControls {
  @Element() hostElement: HTMLEonUiVideoplayerControlsElement;

  /**
   *
   */
  @Event() fullscreenToggleEvent: EventEmitter<void>;

  /**
   *
   */
  @Event() muteToggleEvent: EventEmitter<void>;

  /**
   *
   */
  @Event() playToggleEvent: EventEmitter<void>;

  /**
   *
   */
  @Event() seekEvent: EventEmitter<VideoplayerProgressEventArgs>;

  /**
   *
   */
  @Prop() duration: number;

  /**
   *
   */
  @Prop() isFullscreen: boolean;

  /**
   *
   */
  @Prop() isMuted: boolean;

  /**
   *
   */
  @Prop() isPlaying: boolean;

  /**
   *
   */
  @Prop() percentPlayed: number;

  /**
   *
   */
  @Prop() secondsPlayed: number;

  /**
   *
   */
  @Prop() hideMuteButton: boolean;

  /**
   *
   */
  @Prop() currentLocalization: VideoplayerLocalization;

  /**
   *
   */
  @Prop() hideFullscreenButton: boolean;

  handleSeek(e: MouseEvent): void {
    const { clientX, currentTarget } = e;
    const { left, width } = (currentTarget as Element).getBoundingClientRect();
    const seekPercent = ((clientX - left) / width) * 100;
    const seekSecond = (seekPercent / 100) * this.duration;

    this.seekEvent.emit({ percent: seekPercent, seconds: seekSecond });
  }

  render() {
    const percentPlayedLabel = stringFormat(this.currentLocalization?.percentPlayed, String(this.percentPlayed));

    return (
      <div
        class={pfx({
          controls: true,
          fullscreen: this.isFullscreen
        })}
      >
        {/* Play/Pause button */}
        <button
          class={pfx("button play")}
          title={this.currentLocalization?.togglePlayPause}
          type="button"
          onClick={(_e) => {
            if (_e.x === 0 && _e.y === 0) return;
            this.playToggleEvent.emit();
          }}
        >
          <eon-ui-icon
            no-space="false"
            name={this.isPlaying ? "pause" : "play"}
            title={this.currentLocalization?.togglePlayPause}
          ></eon-ui-icon>
        </button>

        {/* Progress bar */}
        <div class={pfx("progress-bar")}>
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
          <progress
            max={100}
            onClick={(e) => this.handleSeek(e)}
            value={this.percentPlayed || 0}
            /* eslint-disable-next-line */
            tabIndex={0}
          >
            {/* for ScreenReaders: */}
            {percentPlayedLabel}
          </progress>
          <span class={pfx("progress-bar-time")}>
            {`${formatTime(this.secondsPlayed || 0)}/${formatTime(this.duration || 0)}`}
          </span>
        </div>

        {/* Mute/Unmute button */}
        {!this.hideMuteButton && (
          <button
            type="button"
            class={pfx("button mute")}
            onClick={(_e) => this.muteToggleEvent.emit()}
            title={this.currentLocalization?.toggleMute}
          >
            <eon-ui-icon
              no-space="false"
              name={!this.isMuted ? "volume_normal" : "volume_mute"}
              title={this.currentLocalization?.toggleMute}
            ></eon-ui-icon>
          </button>
        )}
        {/* Toggle Fullscreen button */}
        {!this.hideFullscreenButton && (
          <button
            type="button"
            class={pfx("button fullscreen")}
            onClick={(_e) => this.fullscreenToggleEvent.emit()}
            title={this.currentLocalization?.toggleFullscreen}
          >
            <eon-ui-icon
              no-space="false"
              title={this.currentLocalization?.toggleFullscreen}
              name={this.isFullscreen ? "fullscreen_exit" : "fullscreen_enter"}
            ></eon-ui-icon>
          </button>
        )}
      </div>
    );
  }
}
